/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2021-03-17 23:01:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            keyword:'',// 
            online:'',
            starttime:'',// 
            endtime:'',// 
        },
        clearDataP:{
            starttime:'',// 
            endtime:'',// 
        },
        searchRecodeP:{
            starttime:'',// 
            endtime:'',// 
        },
        searchSendMsgRecodeP:{
            devicekey:'',// 
            contextkey:'',// 
            starttime:'',// 
            endtime:'',// 
            msgtype:'',
            sendtype:'',
            isplateform:'',
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {
            devicekeyword:''
        },//
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        // 设备列表
        list(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 在线/离线 设备数
        getSocketDeviceNum(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 在线/离线 历史记录
        queryOnlineDeviceRecord(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 已推送消息 历史记录
        querySocketSendMsgPageList(context, payload) {
            return D.select({
                ...payload
            })

        },

        
        clearHistoryData(context, payload){
            return D.select({
                ...payload
            })
        },
        clearSocketLinkedData(context, payload){
            return D.select({
                ...payload
            })
        },
        //  查询设备在线状态
        querySocketStatusByDevicecode(context, payload) {
            return D.select({
                ...payload
            })
        
        },
        // // 设备记录修改
        // edit(context, payload) {
        //     return D.edit({
        //         ...payload
        //     })

        // },
        
        //详情
        details(context, payload) {
            payload.apikey = 'alarmmanager/details'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        // 列表
        blocklist(context, payload) {
            return D.select({
                ...payload
            })

        },

        // 删除
        deleteblock(context, payload) {
            return D.select({
                ...payload
            })
        },
            
        //清空设备管理搜索条件
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        keyword:'',// 
                        online:'',
                        starttime:'',// 
                        endtime:'',//
                    }
                }
            })
        },
        //清空历史记录搜索条件
        getEmptyRecordSearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchRecodeP: {
                        starttime:'',// 
                        endtime:'',// 
                    }
                }
            })
        },
        //清空日期
        getEmptyClearDataSearch(context){
            context.commit({
                type: 'save',
                payload: {
                    clearDataP: {
                        starttime:'',// 
                        endtime:'',// 
                    }
                }
            })
        },
        //清空历史记录搜索条件
        getEmptySendMsgRecordSearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchSendMsgRecodeP: {
                        devicekey:'',// 
                        contextkey:'',// 
                        starttime:'',// 
                        endtime:'',// 
                        msgtype:'',
                        sendtype:'',
                        isplateform:'',
                    }
                }
            })
        },
    }
}